export const IMAGES = {
  hero_earth: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
  city_night: "https://images.unsplash.com/photo-1542382257-80dedb725088?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  satellite_matrix: "https://images.unsplash.com/photo-1620662892011-f5c2d523fae2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  city_lights: "https://images.unsplash.com/photo-1506747111041-18b1844bf60f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
};

export const STATS = [
  { value: 51, suffix: "", label: "Countries Covered", sub: "Verified national POI databases" },
  { value: 97, suffix: "M+", label: "POI Records", sub: "97,054,299 places and counting" },
  { value: 4000, suffix: "+", label: "Data Categories", sub: "Classified geospatial taxonomies" },
  { value: 20, suffix: "+", label: "Years of Expertise", sub: "Across the geospatial value chain" },
];

export const SERVICES = [
  {
    id: "data-management",
    num: "01",
    title: "Data Management",
    tag: "CREATE / CONVERT / MAINTAIN",
    desc: "With over a decade of experience, DCS helps global corporations in data creation and managing that data effectively and efficiently — from paper records to production geodatabases.",
    features: ["Conversion & Maintenance", "Data Migration", "Cartography & Mapping", "Conflation & Realignment", "Consolidation & Integration"],
    span: "lg",
  },
  {
    id: "imagery-services",
    num: "02",
    title: "Imagery Services",
    tag: "SATELLITE / AERIAL / UAV",
    desc: "Image processing to create and update geographical datasets — remote sensing, photogrammetry and LiDAR that save you significant time and money.",
    features: ["Remote Sensing", "Photogrammetry", "LiDAR & Digital Elevation Models", "Land Cover Classification"],
    span: "md",
  },
  {
    id: "risk-modelling",
    num: "03",
    title: "Risk Modelling & Analytics",
    tag: "HAZARD / EXPOSURE / LOSS",
    desc: "Advanced tools and techniques that help clients optimize risk exposures, improve performance, and increase profits — catastrophe models trusted by insurers worldwide.",
    features: ["Hazard Modelling", "Exposure Development", "Vulnerability Analysis", "Risk Assessment"],
    span: "md",
  },
  {
    id: "it-services",
    num: "04",
    title: "IT Services",
    tag: "CONSULTING / INTEGRATION",
    desc: "We make technology a power tool that increases your company's profitability, productivity and operations — consulting, design, implementation and maintenance since 2015.",
    features: ["IT Consulting", "Turnkey Business Solutions", "24x7 Environment Support", "Systems Integration"],
    span: "md",
  },
  {
    id: "engineering-services",
    num: "05",
    title: "Engineering Services",
    tag: "DESIGN / PROTOTYPE / DELIVER",
    desc: "A multi-disciplined engineering team that understands complex mechanical and electrical problems — turnkey solutions built around flexibility, scalability and cost-effectiveness.",
    features: ["Piping, Civil & Structural", "Instrumentation & Controls", "Prototyping", "Document Control"],
    span: "md",
  },
  {
    id: "geospatial-services",
    num: "06",
    title: "Geospatial Services",
    tag: "INDOOR / OUTDOOR / 3D",
    desc: "End-to-end indoor and outdoor map data development — from 3D indoor venue twins to navigation-grade street databases and surface models.",
    features: ["Indoor Mapping & BIM", "Outdoor Street Databases", "3D Landmarks & Models", "Mobile Video Mapping"],
    span: "lg",
  },
];

export const SERVICE_DETAILS = {
  "data-management": {
    title: "Data Management",
    overline: "SERVICE 01 — DATA LIFECYCLE",
    hero: "Most data do not start digital. We take them there — and keep them there.",
    intro: "DCS has been providing individualized consulting, design, implementation and maintenance since 2015. We are a team of business solutions and technology integration professionals that leading companies trust to get the job done right the first time — every time.",
    blocks: [
      { h: "Conversion & Maintenance", p: "Most data do not initially exist in electronic form; they start out as a work order, survey report, diagram, legal document, or a piece of paper. We have developed methods to enhance, digitize and integrate them into GIS with maximum automation." },
      { h: "Data Migration", p: "DCS has assisted multiple clients in moving out of legacy mapping to better operate their growing networks. Source documentation can come in any format — GIS, CAD, PDF, or paper — and our experts preserve every appropriate detail." },
      { h: "Cartography & Mapping", p: "We are a leader in the conversion of hard copy maps to geodatabases, with specialized knowledge of surveying, land tenure systems, deeds, and legal description interpretation." },
      { h: "Conflation & Realignment", p: "A robust workflow conflates datasets to a geo-referenced land base and enhances them using Positional Accuracy Improvement (PAI) techniques — spatially aligned to a more accurate real-world base." },
      { h: "Consolidation & Integration", p: "We consolidate data from multiple sources, formats, or locations into a single comprehensive GIS database without affecting the real look and feel of the datasets." },
    ],
  },
  "imagery-services": {
    title: "Imagery Services",
    overline: "SERVICE 02 — EARTH OBSERVATION",
    hero: "High-resolution aerial imagery, photogrammetry and LiDAR — cutting-edge technology with scientific expertise.",
    intro: "DCS has provided customers with cutting-edge geospatial data and products, earning a reputation as an unbiased consultant who identifies the right data to solve each customer's pain points.",
    blocks: [
      { h: "Remote Sensing", p: "Proven work with remotely sensed data from a range of satellite sensors, combined with imagery collected by our own fixed-wing and rotary UAVs — land use planning, watershed management, agricultural mapping and stress detection." },
      { h: "Photogrammetry", p: "Earth imaging, orthophoto production, triangulation, stereo data collection, thematic mapping from satellite imagery, terrain modeling and 3D visualization." },
      { h: "LiDAR", p: "Create an extremely detailed digital twin from a single capture source — houses, power lines and roads represented in 3D exactly as they appear in the real world. Delivered to transportation, utilities, government, energy and telecom." },
    ],
  },
  "risk-modelling": {
    title: "Risk Modelling & Analytics",
    overline: "SERVICE 03 — QUANTIFIED RISK",
    hero: "Comprehensive risk analysis. Data-driven decision-making. Access to new opportunities.",
    intro: "DCS has delivered solutions to meet the industry's catastrophe risk management needs, with extensive experience developing models to assess potential losses from man-made and natural hazards.",
    blocks: [
      { h: "Modeling Hazards", p: "Expertise in evaluating natural hazard risks for facilities worldwide — earthquakes, floods, cyclones and more — informing long-term risk reduction strategies and reinsurance protection covers." },
      { h: "Developing Exposures", p: "Building detailed exposure datasets that quantify what is at risk, where, and to what degree — the foundation of every credible loss model." },
      { h: "Analyzing Vulnerabilities", p: "Measuring how hazards impact physical infrastructure, social life and the economy — before they happen." },
      { h: "Risk Assessment", p: "Assessing overall event loss and economic loss to build a complete risk profile for your organisation in a volatile business environment." },
    ],
  },
  "it-services": {
    title: "IT Services",
    overline: "SERVICE 04 — ENTERPRISE TECHNOLOGY",
    hero: "Technology as a power tool — not a constant problem that costs you time and money.",
    intro: "Our IT consulting services help a broad range of customers — from small and medium to large enterprises — address complex problems and make meaningful transformations.",
    blocks: [
      { h: "IT Consulting", p: "Individualized IT consulting, design, implementation and maintenance since 2015. Reduced IT costs, 24x7 availability, improved security, preventive and timely maintenance." },
      { h: "Business Experts", p: "Seamless turnkey business IT solutions without distracting companies from their core business — delivered through customer satisfaction commitments and clear technology leadership." },
      { h: "Technology Partners", p: "Dedicated professionals empowered and committed to 100 percent customer satisfaction, developing optimum business solutions for current and future operating environments." },
      { h: "IT Environment", p: "Unparalleled commitment to service, technology and support. We stand by our work, commit to service levels, and keep your IT environment running smoothly." },
    ],
  },
  "engineering-services": {
    title: "Engineering Services",
    overline: "SERVICE 05 — MULTI-DISCIPLINE ENGINEERING",
    hero: "100% support for the design and engineering processes — from document control to prototyping.",
    intro: "We apply innovative strategies across a range of engineering disciplines to provide turnkey solutions built around flexibility, scalability, and cost-effectiveness — with rich experience in Piping, Civil and Structural, and Instrumentation.",
    blocks: [
      { h: "Optimized Solutions", p: "A strong portfolio of field-proven successes across a wide range of industrial applications — streamlined workflow, improved quality, and minimized cost. Our team uses diverse analytic tools to transform your concept into reality." },
      { h: "Knowledge & Support", p: "Support for lean manufacturing initiatives, sanitary processing requirements, and data acquisition and controls. Well-engineered, well-built solutions with the flexibility to solve immediate challenges and adapt." },
    ],
  },
  "geospatial-services": {
    title: "Indoor & Outdoor Geospatial Services",
    overline: "SERVICE 06 — LOCATION INTELLIGENCE",
    hero: "Indoor mapping that visualizes space and utilization. Outdoor mapping that is spatially accurate.",
    intro: "Indoor mapping is revolutionizing how we view and interact with the world. GIS technologies have stepped indoors to construct 3D virtual environments — while our outdoor teams build navigation-grade street and surface data.",
    blocks: [
      { h: "Indoor Mapping — Creation & Maintenance", p: "Geo-referencing of floor plans, capturing rooms, elevators, escalators and stairs, immovable architectural features, building topology and logical connectivity — delivered in compatible formats." },
      { h: "Indoor Mapping — Client Focus", p: "Unique in-store navigation experiences guiding customers to points of interest within the venue — airports, malls, campuses and large retail chains." },
      { h: "Outdoor Mapping Expertise", p: "High quality points of interest and accurate street databases supporting in-car navigation, web and mobile applications, and location-based services." },
      { h: "Maintenance & Enhancements", p: "End-to-end map data development from specifications creation to production: image processing, digital cartography, street network digitization and realignment, attribute and road sign capture, 3D landmarks and mobile video mapping." },
    ],
  },
};

export const INDUSTRIES = [
  {
    id: "telecom",
    title: "Telecom",
    subtitle: "Wireline & Wireless Communications",
    desc: "Domain-specific GIS solutions for the telecom landscape — cable and broadband services, network planning and design for FTTP, FTTN & HFC technologies, and geo-data for GSM, CDMA, UMTS and WiMAX networks.",
    points: [
      "Network planning & design for FTTP, FTTN and HFC",
      "OSP / ISP GIS data management at production scale",
      "DEM/DTM, clutter, vector and 3D building databases for RF planning",
      "Application development for planning, design and network management",
    ],
  },
  {
    id: "utilities",
    title: "Utilities",
    subtitle: "Electric & Gas Distribution",
    desc: "User-friendly, quality-based and cost-effective GIS services — asset management, network analysis, consumer indexing and performance analysis for electric transmission and distribution, plus integrity management for gas networks.",
    points: [
      "Asset data management & consumer indexing",
      "Network management with traceability and reliability",
      "Spatial analytics: load flow, energy audit, network planning",
      "Distribution integrity management for gas utilities",
    ],
  },
];

export const CATALOG_DATASETS = [
  { id: "poi-global", name: "Global POI Fabric", cat: "Geospatial", records: "97M+", coverage: "51 countries", fmt: "GeoJSON / SHP / API", desc: "Points of interest with 4000+ categories — brands, places and venues, verified nation by nation." },
  { id: "addressing", name: "Addressing Data", cat: "Geospatial", records: "45M+", coverage: "APAC / EMEA / AMER", fmt: "CSV / GDB", desc: "Population-based socio-economic addressing layers, validated and geo-referenced." },
  { id: "foot-geocode", name: "Foot Geocoding", cat: "Geocoding", records: "38M+", coverage: "45+ countries", fmt: "API / Batch", desc: "Rooftop-precision geocoding ingredients at scale, quality-verified." },
  { id: "age-gender", name: "Age Distribution by Gender", cat: "Demographics", records: "12K grids", coverage: "Global grids", fmt: "COG / GeoTIFF", desc: "Popular demographic bundles for site selection and market analysis." },
  { id: "dem-terrain", name: "DEM / DTM Terrain", cat: "Elevation", records: "150M km²", coverage: "Global", fmt: "GeoTIFF / LAS", desc: "Digital elevation and terrain models from LiDAR and photogrammetric capture." },
  { id: "landuse-clutter", name: "Land Use / Clutter", cat: "Telecom", records: "96 regions", coverage: "Urban + rural", fmt: "SHP / TAB", desc: "RF-ready clutter and land-use classification for wireless network planning." },
  { id: "street-network", name: "Street Network & Routing", cat: "Navigation", records: "28M segments", coverage: "51 countries", fmt: "GDF / GeoJSON", desc: "Navigation-grade street databases with attributes and road sign capture." },
  { id: "hazard-layers", name: "Natural Hazard Layers", cat: "Risk", records: "14 perils", coverage: "Global", fmt: "Raster / Vector", desc: "Flood, earthquake, cyclone and wildfire hazard layers for catastrophe modelling." },
];

export const CATALOG_CATEGORIES = ["All", "Geospatial", "Geocoding", "Demographics", "Elevation", "Telecom", "Navigation", "Risk"];

export const TEAM_LEADERSHIP = [
  { name: "Murali Krishna Indukuri", role: "Managing Director & Founder" },
  { name: "Ram Praneeth Yandapalli", role: "Chief Operating Officer" },
  { name: "Seetharamaraju Buddhraju", role: "Head HR" },
  { name: "Karthik Yelipe", role: "Senior Project Leader" },
  { name: "Satya Vara Prasad Karri", role: "Project Leader — Field Operations" },
  { name: "Srinu Kondapalli", role: "Senior Team Leader" },
  { name: "Lakshmi Prasanna Padala", role: "Senior GIS Engineer" },
  { name: "Y Ganesh", role: "Team Leader" },
];

export const TEAM_EXTENDED = [
  "Padmavalli Eyyapu", "Lavanya Polina", "Kavya Santhoshi Kondapalli", "Sudha Amaradhi",
  "Sowjanya Gubbala", "Eswar Kumar Lakkimsetty", "Balasubramanyam Lakkimsetty", "Ravi Kumar Vadrevu",
  "Paddaraju Surabathula", "Jagadeesh Karuparthi", "Ramya Yandapalli", "Madhu Priya Chava",
  "Korlapati Padmini", "Lakshmi Kanth Chevvakula", "Gayathri Devi Udayabhanu", "Jyothi Narala",
  "Pola Raju Satya Sai Udayabhanu", "Jyothikumari Nunna", "Kalyani Nellipudi", "Sandeep Kumar Yedida",
  "Sudheer Kumar Kundrapu", "Venkata N P S Sarat Chandra V.", "Lehar Koppada", "Venkatesh Villa",
  "Sai Ram Chandan Naraharisetti", "Veera Bharat Hyma Ashok T.", "Srestha Sai Pavan Talluri", "Jyothi Talatam",
  "Sadanala Swetha", "Robin James Bhupathi", "Srinivas Neelam", "Akarsh Praveen Atla", "Durga Seshu Chuppana",
];

export const VALUES = [
  { title: "100% Transparency", desc: "Our motto and basic business rule — total process transparency to provide confidence to stakeholders and customers." },
  { title: "People, Process, Performance", desc: "Professionalism linked to every service we provide — the three pillars of every DCS engagement." },
  { title: "Reengineering & Innovation", desc: "Continuously reengineering how geospatial work gets done, to add more value to every client." },
];

export const CAREERS_ROLES = [
  { id: "web-developer", title: "Web Developer", dept: "Engineering", loc: "Kakinada / Remote", type: "Full-time" },
  { id: "web-designer", title: "Web Designer", dept: "Design", loc: "Remote", type: "Full-time" },
  { id: "gis-engineer", title: "GIS Engineer", dept: "Geospatial", loc: "Kakinada", type: "Full-time" },
  { id: "photogrammetrist", title: "Photogrammetry Specialist", dept: "Imagery", loc: "Kakinada", type: "Full-time" },
];

export const CONTACT_INFO = {
  address: ["DESTINYCS PRIVATE LIMITED", "CIN: U74999AP2018PTC108719", "Door No. 1-93, Kovvada,", "Kakinada, East Godavari District,", "Andhra Pradesh 533006, India"],
  phones: ["0884-2355449", "+91 9110501439"],
  email: "contact@destinycs.com",
};

export const MARQUEE_ITEMS = [
  "SATELLITE IMAGERY", "LIDAR POINT CLOUDS", "POI FABRIC — 97M+ RECORDS", "INDOOR DIGITAL TWINS",
  "FTTP NETWORK DESIGN", "CATASTROPHE RISK MODELS", "PHOTOGRAMMETRY", "GLOBAL GEOCODING",
  "ELECTRIC GRID GIS", "STREET NETWORK DATABASES",
];
